const financeOptions = [
  {
    title: '',
    id: '',
    interestAPR: 0,
    monthsToPay: [{ repaymentFactor: 0, months: 0 }],
    administrativeFee: 0
  },
]
const lowDeposit = 0
const highDeposit = 0
const showFinance = false
const showBada = true
const hasMonthlyPayment = false
const hasFullVersion = false
const hasMagnetSimplifiedVersion = false

export default {
  financeOptions,
  lowDeposit,
  highDeposit,
  showFinance,
  showBada,
  hasMonthlyPayment,
  hasFullVersion,
  hasMagnetSimplifiedVersion,
}
